'use strict';

var BreakdownChart = function BreakdownChart(AbstractChart, scalesService, chartGroups, chartSimpleBars, chartTiles, chartXAxis, chartYAxis, chartConstants) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters) {
    var self = this;
    AbstractChart.call(this, container);

    // chart components
    var groups = chartGroups('date', formatters.tooltipFormatter, true);
    var modelBars = chartSimpleBars('model');
    var effectiveTiles = chartTiles('date', 'effective', 'tiles').withHeight(2);
    var effectiveBars = chartSimpleBars('effective');
    var xAxis = chartXAxis(formatters.xAxisTickFormatter);
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT);
    self.render = function (data, range) {
      this.initChart(data, range, chartParams);
      self.scales = chartScales(this.params, this.data, this.visibleXRange);
      this.callForDataGroup([yAxisLeft, groups, effectiveBars, modelBars, effectiveTiles, xAxis], self.scales);
    };
    self.domainChange = function (range) {
      self.render(this.data, range);
    };
    self.withLabel = function (label) {
      yAxisLeft.label(label);
      return self;
    };
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
BreakdownChart.$inject = ['AbstractChart', 'ScalesService', 'ChartElementsGroup', 'ChartElementsSimpleBars', 'ChartElementsTiles', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsConstants'];
module.exports = BreakdownChart;